<template>
  <div>
    <!-- <div class="choose-box--feature">
      <div class="choose-box--feature__small">FEATURES FOR</div>
      <div class="choose-box--feature__large">Physicians</div>
      <div class="choose-box--feature__medium">
        Connect with your community to build your brand image and online
        presence. Share your expertise and support for individuals living with
        chronic conditions.Seamlessly integrate your MyCircles and DoveMed
        profiles to improve brand visibility and share your expertise on your
        profile.
      </div>
    </div> -->
    <div class="create-support  reverse">
      <div class="create-support__image">
        <img
          alt="img"
          src="../../../../assets/images/healthP1.jpg"
          class="img-src"
        />
      </div>
      <div class="create-support__description">
        <div class="create-support__description__small">
          SUPPORT COMMUNITIES
        </div>
        <div class="create-support__description__large">
          That Need Your Expertise Most
        </div>
        <div class="create-support__description__medium">
          Join multiple MyCircles communities to share tips, advice and support
          for individuals living with chronic conditions within your medical
          specialty.
        </div>
      </div>
    </div>
    <div class="create-support  ">
      <div class="create-support__image">
        <img
          alt="img"
          src="../../../../assets/images/healthp2.jpg"
          class="img-src"
        />
      </div>
      <div class="create-support__description">
        <div class="create-support__description__small">NETWORK WITH</div>
        <div class="create-support__description__large">
          Healthcare Professionals
        </div>
        <div class="create-support__description__medium">
          Learn about other healthcare resources for individuals living with
          chronic conditions from healthcare professionals in various MyCircles
          networks.
        </div>
      </div>
    </div>
    <div class="create-support  reverse">
      <div class="create-support__image">
        <img
          alt="img"
          src="../../../../assets/images/healthP3.jpg"
          class="img-src"
        />
      </div>
      <div class="create-support__description">
        <div class="create-support__description__small">
          MANAGE
        </div>
        <div class="create-support__description__large">
          Your Brand Image And Online Presence
        </div>
        <div class="create-support__description__medium">
          Contribute to various MyCircles communities by answering questions and
          sharing expertise on living with chronic conditions that fall within
          your specialty.
        </div>
        <!-- <div class="create-support__description__button">
                CALL TO ACTION
              </div> -->
      </div>
    </div>
    <div class="caregiver full dark-bg">
      <div class="choose-box--feature">
        <div class="choose-box--feature__small">FEATURES FOR</div>
        <div class="choose-box--feature__large ">
          Advance Medical Professionals
        </div>
        <div class="choose-box--feature__medium">
          Following are the Advanced Healthcare Professionals who can
          participate in MyCircles:
        </div>

        <div class="choose-box--feature__choices dovemed-wrapper">
          <div
            class="choose-box--feature__choices--list"
            v-for="i in advanceProfs"
            :key="i"
          >
            <div class="choose-box--feature__choices--list__text">
              {{ i }}
            </div>
          </div>
        </div>
      </div>
      <div class="create-support  dovemed-wrapper reverse">
        <div class="create-support__image">
          <img
            alt="img"
            src="../../../../assets/images/advance1.jpg"
            class="img-src"
          />
        </div>
        <div class="create-support__description">
          <div class="create-support__description__small">SHARE</div>
          <div class="create-support__description__small">
            SUPPORT COMMUNITIES
          </div>
          <div class="create-support__description__large">
            That Need Your Expertise Most
          </div>
          <div class="create-support__description__medium">
            Join multiple MyCircles communities to share tips, advice and
            support for individuals with chronic conditions within your
            knowledge area.
          </div>
        </div>
      </div>
      <div class="create-support dovemed-wrapper  ">
        <div class="create-support__image">
          <img
            alt="img"
            src="../../../../assets/images/advance2.jpg"
            class="img-src"
          />
        </div>
        <div class="create-support__description">
          <div class="create-support__description__small">
            NETWORK WITH
          </div>
          <div class="create-support__description__large">
            Advanced Healthcare Professionals
          </div>
          <div class="create-support__description__medium">
            Learn about healthcare resources for individuals with chronic
            conditions from advanced healthcare professionals in various
            MyCircles networks.
          </div>
        </div>
      </div>
      <div class="create-support dovemed-wrapper reverse ">
        <div class="create-support__image">
          <img
            alt="img"
            src="../../../../assets/images/advance3.jpg"
            class="img-src"
          />
        </div>
        <div class="create-support__description">
          <div class="create-support__description__small">
            MANAGE
          </div>
          <div class="create-support__description__large">
            Your Online Presence
          </div>
          <div class="create-support__description__medium">
            Contribute to various MyCircles communities by answering questions
            and by sharing your knowledge on living with chronic conditions that
            fall within your specialty.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HealthCareStatic",

  data() {
    return {
      advanceProfs: [
        "Anesthesiology Assistant",
        "Certified Clinical Nurse Specialist (CNS)",
        "Certified Nurse Midwife (CNM)",
        "Certified Registered Nurse Anesthetist (CRNA)",
        "Chiropractic",
        "Clinical Psychologist",
        "Clinical Social Worker",
        "Nurse Practitioner",
        "Occupational Therapy",
        "Optometry",
        "Physical Therapy",
        "Physician Assistant",
        "Qualified Audiologist",
        "Qualified Speech Language Pathologist",
        "Registered Dietitian or Nutrition Professional"
      ]
    };
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/App/circle/AllCircleStaticPages/HealthCareProfessionalStatic.vue